import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, List, ListItem, Notice, scrollToElement, Separator } from 'telia-front-react';
import { useEffect } from 'react';
import { useNoticeStores } from '../stores/NoticeRootStore';
export const FORM_ERROR_NOTICE_ID = 'gravity-form-error-notice';
const FieldValidationErrorNotice = observer((props) => {
    const { fieldValidationStore: { erroredFields, shouldHideErrorNoticeInHeader }, translateStore: { translate } } = useNoticeStores();
    const { inFormHeader } = props;
    const shouldShowNotice = (erroredFields === null || erroredFields === void 0 ? void 0 : erroredFields.size) > 0 && (!shouldHideErrorNoticeInHeader || !inFormHeader);
    useEffect(() => {
        scrollToElement(FORM_ERROR_NOTICE_ID, null, 125, true);
    }, [erroredFields]);
    return (React.createElement("div", { role: "alert" }, shouldShowNotice && (React.createElement(React.Fragment, null,
        React.createElement(Notice, { id: FORM_ERROR_NOTICE_ID, type: "error" },
            translate('form.error'),
            (erroredFields === null || erroredFields === void 0 ? void 0 : erroredFields.size) > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                React.createElement(List, { type: "unstyled" }, Array.from(erroredFields).map(([erroredFieldId, label]) => (React.createElement(ListItem, { key: `erroredField-${erroredFieldId}-button` },
                    React.createElement(Button, { text: label, type: "withdrawal", link: true, onClick: () => {
                            scrollToElement(erroredFieldId, null, null, true);
                        } })))))))),
        inFormHeader && React.createElement(Separator, { spacing: "xsmall", color: "invisible" })))));
});
export default FieldValidationErrorNotice;
//# sourceMappingURL=FieldValidationErrorNotice.js.map